import { ErrorMessage, ZipCodeInput } from '@hc-frontend/core-ui';
import { FormEvent, useState } from 'react';
import { z } from 'zod';

import { ZIP_CODE, ZIP_CODE_SCHEMA } from './constants';
import { FormButtons } from './form-buttons';
import { useSubsidyCalculator } from './provider';

const FormSchema = z.object({
  zipCode: ZIP_CODE_SCHEMA,
});

export function LocationStep() {
  const { setStep } = useSubsidyCalculator();
  const { answers, setAnswer } = useSubsidyCalculator();
  const [zipCode, setZipCode] = useState(answers[ZIP_CODE] ?? '');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError(null);

    const result = FormSchema.safeParse({ zipCode });
    if (result.success) {
      setAnswer(ZIP_CODE, result.data.zipCode);
      setStep((v) => v + 1);
    } else {
      setError('Please enter a valid zip code.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <ZipCodeInput
        className="max-w-none animate-in fade-in slide-in-from-bottom-8-8 duration-1000 fill-mode-both"
        label="Zip Code"
        placeholder="e.g. 33133"
        helpText="Enter your 5-digit ZIP code to find plans in your area"
        withButton={false}
        name={ZIP_CODE}
        value={zipCode}
        onChange={(e) => setZipCode(e.target.value)}
        errorText={error ? <ErrorMessage>{error}</ErrorMessage> : undefined}
      />

      <FormButtons className="animate-in fade-in slide-in-from-bottom-8-8 duration-1000 delay-150 fill-mode-both" />
    </form>
  );
}
